module.exports = __webpack_public_path__ + "static/media/forme.42d6cec6.svg";